/**
 * B2B Cart Validation v5
 * Verhindert das Mischen von B2B-Rollenprodukten mit normalen Artikeln
 * Handled B2B-Buttons direkt + intercepted alle Add-to-Cart Methoden
 */

(function() {
  'use strict';

  let pendingAddData = null;
  let isOurRequest = false;

  // Modal erstellen
  function createModal() {
    if (document.getElementById('b2b-cart-modal')) return;
    
    const modalHTML = `
      <div id="b2b-cart-modal" style="display:none; position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.6); z-index:999999; justify-content:center; align-items:center;">
        <div style="background:#fff; padding:2rem; border-radius:12px; max-width:450px; margin:1rem; text-align:center; box-shadow:0 4px 20px rgba(0,0,0,0.15);">
          <div style="margin-bottom:1.5rem;">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#e67e22" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
          </div>
          <h3 style="margin:0 0 1rem; font-size:1.25rem; color:#212529;" id="b2b-modal-title">Hinweis</h3>
          <p style="margin:0 0 1.5rem; color:#495057; line-height:1.6;" id="b2b-modal-message"></p>
          <div style="display:flex; flex-direction:column; gap:0.75rem;">
            <button id="b2b-modal-confirm" type="button" style="background:#212529; color:#fff; border:none; padding:0.875rem 1.5rem; border-radius:8px; font-size:1rem; cursor:pointer; font-weight:500;">Warenkorb leeren & fortfahren</button>
            <button id="b2b-modal-cancel" type="button" style="background:#fff; color:#212529; border:1px solid #212529; padding:0.875rem 1.5rem; border-radius:8px; font-size:1rem; cursor:pointer; font-weight:500;">Abbrechen</button>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    document.getElementById('b2b-modal-confirm').addEventListener('click', handleConfirm);
    document.getElementById('b2b-modal-cancel').addEventListener('click', hideModal);
    document.getElementById('b2b-cart-modal').addEventListener('click', function(e) {
      if (e.target === this) hideModal();
    });
  }

  function showModal(isB2BProduct) {
    createModal();
    const modal = document.getElementById('b2b-cart-modal');
    const title = document.getElementById('b2b-modal-title');
    const message = document.getElementById('b2b-modal-message');
    
    if (isB2BProduct) {
      title.textContent = 'Rollenware - Separate Bestellung';
      message.textContent = 'Gummibaender auf Rolle werden direkt vom Hersteller CharLe geliefert und koennen nicht zusammen mit anderen Artikeln bestellt werden. Moechtest du deinen Warenkorb leeren und fortfahren?';
    } else {
      title.textContent = 'Hinweis';
      message.textContent = 'Dein Warenkorb enthaelt Rollenware, die direkt vom Hersteller geliefert wird. Diese kann nicht zusammen mit anderen Artikeln bestellt werden. Moechtest du deinen Warenkorb leeren und fortfahren?';
    }
    modal.style.display = 'flex';
  }

  function hideModal() {
    const modal = document.getElementById('b2b-cart-modal');
    if (modal) modal.style.display = 'none';
    pendingAddData = null;
  }

  function cartHasB2BItems(cart) {
    return cart.items.some(item => item.properties && item.properties._b2b_only === 'true');
  }

  function cartHasRegularItems(cart) {
    return cart.items.some(item => !item.properties || item.properties._b2b_only !== 'true');
  }

  async function getCart() {
    const response = await fetch('/cart.js', { method: 'GET' });
    return response.json();
  }

  async function addToCart(data) {
    isOurRequest = true;
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    isOurRequest = false;
    return response.json();
  }

  async function clearCart() {
    isOurRequest = true;
    await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
    isOurRequest = false;
  }

  function refreshPage() {
    window.location.reload();
  }

  async function handleConfirm() {
    if (!pendingAddData) {
      hideModal();
      return;
    }
    
    const btn = document.getElementById('b2b-modal-confirm');
    btn.textContent = 'Wird verarbeitet...';
    btn.disabled = true;
    
    try {
      await clearCart();
      await addToCart(pendingAddData);
      refreshPage();
    } catch (error) {
      console.error('Fehler:', error);
      alert('Es gab einen Fehler. Bitte versuche es erneut.');
      hideModal();
    }
  }

  // ============================================
  // B2B Button Handler
  // ============================================
  
  async function handleB2BButtonClick(button) {
    const variantId = button.dataset.variantId;
    const quantityInputId = button.dataset.quantityInput;
    const quantityInput = document.getElementById(quantityInputId);
    const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
    
    const originalText = button.textContent;
    button.textContent = 'Wird geprueft...';
    button.disabled = true;
    
    try {
      const cart = await getCart();
      const hasRegularItems = cartHasRegularItems(cart);
      
      const itemData = {
        items: [{
          id: parseInt(variantId),
          quantity: quantity,
          properties: { _b2b_only: 'true' }
        }]
      };
      
      if (cart.item_count > 0 && hasRegularItems) {
        pendingAddData = itemData;
        showModal(true);
        button.textContent = originalText;
        button.disabled = false;
      } else {
        button.textContent = 'Wird hinzugefuegt...';
        await addToCart(itemData);
        refreshPage();
      }
    } catch (error) {
      console.error('Fehler:', error);
      alert('Es gab einen Fehler. Bitte versuche es erneut.');
      button.textContent = originalText;
      button.disabled = false;
    }
  }

  document.addEventListener('click', function(e) {
    const button = e.target.closest('.b2b-add-to-cart');
    if (button) {
      e.preventDefault();
      handleB2BButtonClick(button);
    }
  });

  // ============================================
  // Interceptors fuer normale Artikel
  // ============================================

  // XMLHttpRequest Interceptor
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    this._method = method;
    return originalXHROpen.apply(this, arguments);
  };
  
  XMLHttpRequest.prototype.send = function(body) {
    const xhr = this;
    
    if (this._url && this._url.includes('/cart/add') && !isOurRequest) {
      // Synchron den Cart pruefen geht nicht - wir muessen async arbeiten
      // Stattdessen: Request durchlassen, aber Cart nachher pruefen und ggf. rueckgaengig machen
      // Das ist nicht ideal, aber XMLHttpRequest laesst sich nicht async blockieren
    }
    
    return originalXHRSend.apply(this, arguments);
  };

  // Fetch Interceptor
  const originalFetch = window.fetch;
  window.fetch = async function(url, options) {
    if (isOurRequest) {
      return originalFetch.apply(this, arguments);
    }
    
    if (typeof url === 'string' && url.includes('/cart/add') && options?.body) {
      let isB2B = false;
      let itemData = null;
      
      try {
        if (typeof options.body === 'string') {
          const data = JSON.parse(options.body);
          isB2B = (data.properties && data.properties._b2b_only === 'true') ||
                  (data.items && data.items.some(i => i.properties && i.properties._b2b_only === 'true'));
          itemData = data.items ? data : { items: [data] };
        }
        if (options.body instanceof FormData) {
          isB2B = options.body.get('properties[_b2b_only]') === 'true';
          const item = { 
            id: options.body.get('id'), 
            quantity: parseInt(options.body.get('quantity')) || 1,
            properties: {}
          };
          for (let [k, v] of options.body.entries()) {
            if (k.startsWith('properties[')) {
              item.properties[k.replace('properties[', '').replace(']', '')] = v;
            }
          }
          itemData = { items: [item] };
        }
      } catch (e) {
        console.log('Parse error:', e);
      }
      
      // Nur fuer NICHT-B2B Artikel pruefen
      if (!isB2B) {
        try {
          const cart = await getCart();
          const hasB2B = cartHasB2BItems(cart);
          
          if (cart.item_count > 0 && hasB2B) {
            pendingAddData = itemData;
            showModal(false);
            throw new Error('B2B_CART_CONFLICT');
          }
        } catch (e) {
          if (e.message === 'B2B_CART_CONFLICT') {
            return Promise.reject(e);
          }
        }
      }
    }
    
    return originalFetch.apply(this, arguments);
  };

  // Form Submit Interceptor (Fallback)
  document.addEventListener('submit', async function(e) {
    const form = e.target;
    
    // Ignoriere B2B forms (die haben kein action mehr)
    if (form.classList.contains('b2b-custom-form')) return;
    if (!form.action || !form.action.includes('/cart/add')) return;
    
    // Pruefe ob B2B im Warenkorb
    try {
      const cart = await getCart();
      const hasB2B = cartHasB2BItems(cart);
      
      if (cart.item_count > 0 && hasB2B) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const formData = new FormData(form);
        const item = { 
          id: formData.get('id'), 
          quantity: parseInt(formData.get('quantity')) || 1,
          properties: {}
        };
        for (let [k, v] of formData.entries()) {
          if (k.startsWith('properties[')) {
            item.properties[k.replace('properties[', '').replace(']', '')] = v;
          }
        }
        pendingAddData = { items: [item] };
        showModal(false);
        return false;
      }
    } catch (e) {
      console.error('Form check error:', e);
    }
  }, true);

  // Button Click Interceptor (fruehester Punkt)
  document.addEventListener('click', async function(e) {
    const button = e.target.closest('button[type="submit"], button[name="add"], .product-form__submit');
    if (!button) return;
    
    // Ignoriere unsere B2B buttons
    if (button.classList.contains('b2b-add-to-cart')) return;
    
    const form = button.closest('form');
    if (!form) return;
    if (!form.action || !form.action.includes('/cart/add')) return;
    
    // Pruefe ob B2B im Warenkorb
    try {
      const cart = await getCart();
      const hasB2B = cartHasB2BItems(cart);
      
      if (cart.item_count > 0 && hasB2B) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const formData = new FormData(form);
        const item = { 
          id: formData.get('id'), 
          quantity: parseInt(formData.get('quantity')) || 1,
          properties: {}
        };
        for (let [k, v] of formData.entries()) {
          if (k.startsWith('properties[')) {
            item.properties[k.replace('properties[', '').replace(']', '')] = v;
          }
        }
        pendingAddData = { items: [item] };
        showModal(false);
        return false;
      }
    } catch (e) {
      console.error('Button check error:', e);
    }
  }, true);

  console.log('B2B Cart Validation v5 geladen');
})();
